import { connect } from "react-redux";
import { formValueSelector, getFormValues, getFormSyncErrors } from "redux-form";
import { bindActionCreators } from "redux";
import Form from "../../components/forms/Statement/StatementForm";
import {
  newStatement, sendStatement, incompleteStatement, withRedirect, withRedirectBack, getStatementPdf, getMe
} from '../../CroActions';
import { isOfficial, isInternal, isLegitimate, isOfficialAdmin } from '../../CroUtils';
import { breadcrumbs } from '../../../../actions/appActions';
import { convert, addressToForm } from '../../converts';
import { StatementStateRaw, VisibilityRaw } from '../../enum';
import { noop } from 'lodash';
import { idObj } from '../../../../utils';

const postProcess = data => convert(data, {
  statementOfficial: { birthAddress: addressToForm, deliveryAddress: addressToForm },
  naturalPersonBusinesses: { address: addressToForm },
  legalBusinessAssociates: { legalPerson: { address: addressToForm } },
  organizationMember: { legalPerson: { address: addressToForm } },
  otherContracts: { address: addressToForm },
  corporationShares: { address: addressToForm },
  corporationSharesBefore: { address: addressToForm },
  incomes: { legalPerson: { address: addressToForm } },
  liabilities: { legalPerson: { address: addressToForm } },
  media: { legalPerson: { address: addressToForm } },
  realties: addressToForm,
  realtiesBefore: addressToForm,
});
const selector = formValueSelector('statementForm');
const allData = getFormValues('statementForm');

const mapStateToProps = (state, { params, auth = {}, location }) => ({
  breadcrumbsItems: isLegitimate(auth)
    ? [{ label: "Oznámení" }]
    : [{ label: "Oznámení" }, { label: "Editovat oznámení" }],

  cloneStatement: location.state && location.state.cloneStatement,

  naturalPersonBusinessesEnabled: selector(
    state,
    "naturalPersonBusinessesEnabled",
  ), // || null,
  legalBusinessAssociatesEnabled: selector(
    state,
    "legalBusinessAssociatesEnabled",
  ), // || null,
  organizationMemberEnabled: selector(state, "organizationMemberEnabled"), // || null,
  mediaEnabled: selector(state, "mediaEnabled"), // || null,
  otherContractsEnabled: selector(state, "otherContractsEnabled"), // || null,
  realtiesEnabled: selector(state, "realtiesEnabled"), // || null,
  realtiesBeforeEnabled: selector(state, "realtiesBeforeEnabled"), // || null,
  commercialPapersEnabled: selector(state, "commercialPapersEnabled"), // || null,
  commercialPapersBeforeEnabled: selector(
    state,
    "commercialPapersBeforeEnabled",
  ), // || null,
  corporationSharesEnabled: selector(state, "corporationSharesEnabled"), // || null,
  corporationSharesBeforeEnabled: selector(
    state,
    "corporationSharesBeforeEnabled",
  ), // || null,
  chattelsEnabled: selector(state, "chattelsEnabled"), // || null,
  chattelsBeforeEnabled: selector(state, "chattelsBeforeEnabled"), // || null,
  incomesEnabled: selector(state, "incomesEnabled"), // || null,
  liabilitiesEnabled: selector(state, "liabilitiesEnabled"), // || null,

  realties: selector(state, "realties") || null,
  realtiesBefore: selector(state, "realtiesBefore") || null,
  commercialPapers: selector(state, "commercialPapers") || null,
  commercialPapersBefore: selector(state, "commercialPapersBefore") || null,
  corporationShares: selector(state, "corporationShares") || null,
  corporationSharesBefore: selector(state, "corporationSharesBefore") || null,
  chattels: selector(state, "chattels") || null,
  chattelsBefore: selector(state, "chattelsBefore") || null,
  incomes: selector(state, "incomes") || null,
  associates: selector(state, "legalBusinessAssociates") || null,
  business: selector(state, "naturalPersonBusinesses") || null,
  liabilities: selector(state, "liabilities") || null,
  media: selector(state, "media") || null,
  organizationMember: selector(state, "organizationMember") || null,
  otherContracts: selector(state, "otherContracts") || null,

  statementOfficial: selector(state, "statementOfficial") || null,

  toDate: selector(state, "toDate") || null,
  fromDate: selector(state, "fromDate") || null,

  promiseDocumented: selector(state, "official.promiseDocumented") || false,
  //workingPositions: selector(state, 'workingPositions') || [],
  workingPositions: selector(state, "officialWorkingPositions") || [],
  workingPositionsAll: selector(state, "official.workingPositions"),

  deputy: selector(state, "official.deputy") || false,
  deputyAndOthers: selector(state, "official.deputyAndOthers") || false,
  senator: selector(state, "official.senator") || false,
  senatorAndOthers: selector(state, "official.senatorAndOthers") || false,
  dos:
    selector(state, "official.deputy") ||
    selector(state, "official.senator") ||
    false,
  dosStatement: selector(state, "senator") || false,
  type_senator: selector(state, "type_senator"),
  hasPoint3: selector(state, "official.hasPoint3") || false,
  getMe,

  officialId: selector(state, "official.id"),
  getAllData: () => allData(state),

  hasFileRef: selector(state, 'hasFileRef'),

  lastModified: selector(state, 'lastModified'),
  creationDate: selector(state, 'creationDate'),

  isVillage: selector(state, 'isVillage'),
  isCity: selector(state, 'isCity'),
  isReleased: selector(state, 'isReleased'),

  type: selector(state, 'type'),
  state: selector(state, 'state'),
  checked: selector(state, 'checked'),
  visibility: selector(state, 'statementOfficial.visibility'),
  disabled:
    !(location.state && location.state.cloneStatement) &&
    ((!isOfficial(auth) && !isInternal(auth)) ||
    (isOfficial(auth) &&
      selector(state, "state") === StatementStateRaw.ACCEPT) ||
      (isInternal(auth) && !isOfficialAdmin(auth)) ||
      (isInternal(auth) && selector(state, "state") === StatementStateRaw.NEW)),
  url: isOfficial(auth)
    ? `${auth.startUrl}/api/oznameni/${params.id}`
    : `${auth.startUrl}/api/funkcionari/${params.id}/oznameni/${params.statement_id}`,
  postProcess,
  isPublicStatement:
    selector(state, "visibility") === VisibilityRaw.PUBLIC || false,
  invalidFields: getFormSyncErrors('statementForm')(state),
  useAsTemplateDisabled: selector(state, "useAsTemplateDisabled") || false,
  statementId: selector(state, "id") || null,
});

const onSubmit = (startUrl, params) =>
  withRedirect(newStatement(startUrl), startUrl.includes('funkcionar') ? '/funkcionar/oznameni' : `/administrator/funkcionari/form/${params.id}`);
const onSend = (startUrl) => withRedirect(data => async dispatch => {
  const idData = idObj(data);
  await newStatement(startUrl)(idData, null)(dispatch);
  await sendStatement(idData)(dispatch);
}, '/funkcionar/oznameni');
const onChecked = (startUrl) => noop;

const onIncomplete = (startUrl) => withRedirectBack(incompleteStatement(startUrl));

const mapDispatchToProps = (dispatch, { params, auth = {} }) => ({
  ...bindActionCreators(
    {
      breadcrumbs,
      exportPdf: getStatementPdf(auth.startUrl),
      exportPdfRequest: getStatementPdf(auth.startUrl, "request"),
    },
    dispatch,
  ),
  onSubmit: (data) => dispatch(onSubmit(auth.startUrl, params)(data)),
  onSend: data => isOfficial(auth) ? dispatch(onSend(auth.startUrl)(data)) : noop,
  onIncomplete: () => isInternal(auth) ? dispatch(onIncomplete(auth.startUrl)(params)) : noop,
  onChecked: () => isInternal(auth) ? dispatch(onChecked(auth.startUrl)(params)) : noop
})

export default connect(mapStateToProps, mapDispatchToProps)(Form);
